import React, { useContext } from 'react';
import ReviewGroup from '../item/item-group';
import { enrollmentContext } from '../../../../../hoc/context/enrollment/enrollment-context';
import context from '../../../../../hoc/context/product/context';
import {
	ConsentIDs,
	ServiceNames,
} from '../../../../../hoc/constants/service.constants';

const ConsentInfo: React.FC<{}> = () => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const adherenceService = ctxt.json.services.find(
		(cardService) => cardService.name === ServiceNames.adherence
	);
	// Data structure to be shown
	const data = [];
	if (ctxt.json.consents[ConsentIDs.hipaa]) {
		data.push({
			label: ctxt.json.pages.review.hipaaAgreedLabel,
			value: enrollmentCtxt.input.consents.includes(ConsentIDs.hipaa)
				? 'Yes'
				: 'No',
		});
	}
	if (
		ctxt.json.consents[ConsentIDs.tcpa] &&
		adherenceService &&
		enrollmentCtxt.isServiceEligible(adherenceService)
	) {
		const tcpa = enrollmentCtxt.input.consents.includes(ConsentIDs.tcpa);
		data.push({
			label: ctxt.json.pages.review.tcpaAgreedLabel,
			value: tcpa ? 'Yes' : 'No',
		});
		if (tcpa) {
			data.push({
				label: ctxt.json.pages.review.enrollmentBestTime,
				value:
					ctxt.json.pages.review[
						`enrollmentBestTime${
							enrollmentCtxt.getFormField('bestTimeToConnect')?.value
						}`
					],
			});
		}
	}

	return <ReviewGroup items={data} />;
};
export default ConsentInfo;
